import { Activity_DocumentEvidence, Maturity, Action_Category, DomainEntities } from "../DomainEvents.fs.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { TaskMsg, useFeliz_UseElmish_React__React_useTaskDispatch_Static } from "../hooks/UseTaskDispatch.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { some, bind, toArray, defaultArg, unwrap, map, orElse } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { PromiseBuilder__While_2044D34, PromiseBuilder__For_1565554B, PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { newGuid } from "../fable_modules/fable-library-js.4.24.0/Guid.js";
import { DomainEntity__get_Name, ProjectPage_CreateQRCodeUrl, Target__get_Name, Target__get_Id, DomainEntity__get_Id } from "../ClientTypes.fs.js";
import { Activities_ChangeAction, Activities_ChangeMaturity, Activities_ChangeCategory, Activities_CompleteActivityStep, Activities_EvidenceType, Activities_RevertActivityStep, Documents_CreateDocument, Documents_ChangeReferences, Activities_Signed, Activities_UnSigned, Activities_CompletionTime, Activities_ExpectedCompletionDate, Activities_AssignUser, Activities_UpdateActivity, Activities_StartActivity, Activities_TargetEntity } from "../ServerTypes.fs.js";
import { Csv_encode, EPM_Domain_Events_Attribute__Attribute_ValueString, EPM_Domain_Events_Action_Category__Category_ToProperString, EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString, System_String__String_ToOption_Static_Z721C83C5 } from "../Prelude.fs.js";
import { ofList, FSharpMap__TryFind, FSharpMap__Add, empty } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { safeHash, equals as equals_1, int32ToString, compare, numberHash, dateHash, stringHash, createObj, comparePrimitives } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { changeAction, changeMaturity, changeCategory as changeCategory_1, completeStepWithAttachments, completeStep as completeStep_1, revertStep as revertStep_1, export$, count, signOff as signOff_2, single, unsign as unsign_2, setActualTime as setActualTime_1, setEstimatedTime as setEstimatedTime_1, setExpectedDate as setExpectedDate_1, assignUser as assignUser_1, update as update_1, create as create_2 } from "../Api/Activities.fs.js";
import { Components_VideoFeed, Components_FetchErrorNotification, Modal_ModalWithFooter, Modal_ModalWithBreakdown } from "./Modal.fs.js";
import { length as length_1, mapIndexed, collect, map as map_2, iterate, empty as empty_1, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { interpolate, toText, isNullOrWhiteSpace, join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { collect as collect_1, iterate as iterate_1, reverse, ofSeq, append as append_1, head, tail, isEmpty, map as map_1, tryHead, length, choose, empty as empty_2, cons, singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { UserSelector_UserSelector, DomainEntityTypeSelector_DomainEntitySelector, MaturitySelector_MaturitySelector, CategorySelector_CategorySelector } from "../components/Components.fs.js";
import { DomainEntitiesSelector, DomainEntitySelector } from "../components/EntitySelector.fs.js";
import { EPM_Domain_Events_Action_Category__Category_ToUrlString } from "../Api/../Prelude.fs.js";
import { defaultOf } from "../fable_modules/Feliz.2.9.0/../Feliz.Router.4.0.0/../fable-library-js.4.24.0/Util.js";
import { groupBy, List_groupBy } from "../fable_modules/fable-library-js.4.24.0/Seq2.js";
import { toString as toString_1, utcNow, equals } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { utcNow as utcNow_1, fromDate, date as date_1 } from "../fable_modules/fable-library-js.4.24.0/DateOffset.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { parse } from "../fable_modules/Feliz.2.9.0/./DateParsing.fs.js";
import { fromHours, totalHours } from "../fable_modules/fable-library-js.4.24.0/TimeSpan.js";
import { useFeliz_React__React_useOptionalFetch_Static_5B82200F, useFeliz_React__React_useFetch_Static_6ADA66EC, Fetched$1_toOption_50D43789 } from "../hooks/UseFetch.fs.js";
import { targetEntity } from "../Api/Entities.fs.js";
import { many, createUpload, changeReferences } from "../Api/Documents.fs.js";
import { union, ofSeq as ofSeq_1, FSharpSet__Contains, ofList as ofList_1, empty as empty_3, add } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { rangeDouble } from "../fable_modules/fable-library-js.4.24.0/Range.js";
import { Fa_IconOption, Fa_i } from "../fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { StringBuilder__AppendLine_Z721C83C5, StringBuilder_$ctor } from "../fable_modules/fable-library-js.4.24.0/System.Text.js";
import file_saver from "file-saver";

const documentEntityType = new DomainEntities(9, []);

export function StartActivity(startActivityInputProps) {
    let xs_32;
    const close = startActivityInputProps.close;
    const initialCategory = startActivityInputProps.initialCategory;
    const projectId = startActivityInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const useAction = patternInput_1[0];
    const patternInput_2 = reactApi.useState("");
    const comment = patternInput_2[0];
    const patternInput_3 = reactApi.useState("");
    const name = patternInput_3[0];
    const patternInput_4 = reactApi.useState("");
    const detail = patternInput_4[0];
    let patternInput_5;
    const initial_4 = orElse(initialCategory, new Action_Category(0, []));
    patternInput_5 = reactApi.useState(initial_4);
    const categoryOpt = patternInput_5[0];
    const patternInput_6 = reactApi.useState(new Maturity(0, []));
    const maturityOpt = patternInput_6[0];
    const patternInput_7 = reactApi.useState(undefined);
    const actionOpt = patternInput_7[0];
    const patternInput_8 = reactApi.useState(undefined);
    const entityTypeOpt = patternInput_8[0];
    const patternInput_9 = reactApi.useState(undefined);
    const entityOpt = patternInput_9[0];
    let create_1;
    const dependencies_1 = [comment, actionOpt, entityTypeOpt, entityOpt, name, detail, useAction, categoryOpt, maturityOpt];
    create_1 = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let entity, entityType;
            const taskId = newGuid();
            taskDispatch(new TaskMsg(0, [taskId, "Start"]));
            const target = (entityOpt != null) ? ((entityTypeOpt != null) ? ((entity = entityOpt, (entityType = entityTypeOpt, new Activities_TargetEntity(DomainEntity__get_Id(entity), entityType)))) : undefined) : undefined;
            let create;
            const ActionId = useAction ? map(DomainEntity__get_Id, actionOpt) : undefined;
            const Comment$ = System_String__String_ToOption_Static_Z721C83C5(comment);
            create = (new Activities_StartActivity(ActionId, target, !useAction ? System_String__String_ToOption_Static_Z721C83C5(name) : undefined, !useAction ? System_String__String_ToOption_Static_Z721C83C5(detail) : undefined, Comment$, !useAction ? categoryOpt : undefined, !useAction ? maturityOpt : undefined, empty({
                Compare: comparePrimitives,
            })));
            taskDispatch(new TaskMsg(2, [taskId]));
            return create_2(projectId, create).then((_arg) => {
                const result = _arg;
                if (result.tag === 1) {
                    taskDispatch(new TaskMsg(6, [taskId, result.fields[0]]));
                    return Promise.resolve();
                }
                else {
                    taskDispatch(new TaskMsg(3, [taskId, undefined]));
                    return Promise.resolve();
                }
            });
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_32 = toList(delay(() => {
            let elms, elems;
            return append(singleton((elms = ofArray([createElement("label", {
                className: "label",
                children: useAction ? "Create activity with action" : "Create activity with-out action",
            }), createElement("div", createObj(Helpers_combineClasses("control", ofArray([["className", join(" ", ["description-toggle", "pretty", "p-switch", "p-fill"])], (elems = [createElement("input", {
                type: "checkbox",
                defaultChecked: useAction,
                onClick: (_arg_1) => {
                    patternInput_1[1](!useAction);
                },
            }), createElement("div", {
                className: "state",
                children: createElement("label", {}),
            })], ["children", reactApi.Children.toArray(Array.from(elems))])]))))]), createElement("div", {
                className: "field",
                children: reactApi.Children.toArray(Array.from(elms)),
            }))), delay(() => {
                let elms_1;
                return append((initialCategory == null) ? singleton((elms_1 = ofArray([createElement("label", {
                    className: "label",
                    children: "Category",
                }), createElement(CategorySelector_CategorySelector, {
                    value: unwrap(categoryOpt),
                    required: true,
                    onChange: patternInput_5[1],
                })]), createElement("div", {
                    className: "field",
                    children: reactApi.Children.toArray(Array.from(elms_1)),
                }))) : empty_1(), delay(() => {
                    let matchValue_1, category, elms_2, elms_4, elms_3;
                    return append(useAction ? ((matchValue_1 = categoryOpt, (matchValue_1 != null) ? ((category = matchValue_1, singleton((elms_2 = ofArray([createElement("label", {
                        className: "label",
                        children: "Action",
                    }), createElement(DomainEntitySelector, {
                        projectId: projectId,
                        entityType: new DomainEntities(11, []),
                        onSelectedEntityChange: patternInput_7[1],
                        filters: singleton_1(["category", EPM_Domain_Events_Action_Category__Category_ToUrlString(category)]),
                        isSmall: false,
                    })]), createElement("div", {
                        className: "field",
                        children: reactApi.Children.toArray(Array.from(elms_2)),
                    }))))) : singleton(defaultOf()))) : append(singleton((elms_4 = ofArray([createElement("label", {
                        className: "label",
                        children: "Name",
                    }), (elms_3 = singleton_1(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
                        patternInput_3[1](ev.target.value);
                    }], ["defaultValue", name]])))))), createElement("div", {
                        className: "control",
                        children: reactApi.Children.toArray(Array.from(elms_3)),
                    }))]), createElement("div", {
                        className: "field",
                        children: reactApi.Children.toArray(Array.from(elms_4)),
                    }))), delay(() => {
                        let elms_6, elms_5;
                        return append(singleton((elms_6 = ofArray([createElement("label", {
                            className: "label",
                            children: "Detail",
                        }), (elms_5 = singleton_1(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev_1) => {
                            patternInput_4[1](ev_1.target.value);
                        }], ["defaultValue", detail]])))))), createElement("div", {
                            className: "control",
                            children: reactApi.Children.toArray(Array.from(elms_5)),
                        }))]), createElement("div", {
                            className: "field",
                            children: reactApi.Children.toArray(Array.from(elms_6)),
                        }))), delay(() => {
                            let elms_7;
                            return singleton((elms_7 = ofArray([createElement("label", {
                                className: "label",
                                children: "Maturity",
                            }), createElement(MaturitySelector_MaturitySelector, {
                                value: unwrap(maturityOpt),
                                required: true,
                                onChange: patternInput_6[1],
                            })]), createElement("div", {
                                className: "field",
                                children: reactApi.Children.toArray(Array.from(elms_7)),
                            })));
                        }));
                    })), delay(() => {
                        let elms_8;
                        return append(singleton((elms_8 = ofArray([createElement("label", {
                            className: "label",
                            children: "Against",
                        }), createElement(DomainEntityTypeSelector_DomainEntitySelector, {
                            value: unwrap(entityTypeOpt),
                            required: false,
                            onChange: patternInput_8[1],
                        })]), createElement("div", {
                            className: "field",
                            children: reactApi.Children.toArray(Array.from(elms_8)),
                        }))), delay(() => {
                            let matchValue_2, entityType_1, elms_9;
                            return append((matchValue_2 = entityTypeOpt, (matchValue_2 != null) ? ((entityType_1 = matchValue_2, singleton((elms_9 = ofArray([createElement("label", {
                                className: "label",
                                children: EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString(entityType_1),
                            }), createElement(DomainEntitySelector, {
                                projectId: projectId,
                                entityType: entityType_1,
                                onSelectedEntityChange: patternInput_9[1],
                                filters: empty_2(),
                                isSmall: false,
                            })]), createElement("div", {
                                className: "field",
                                children: reactApi.Children.toArray(Array.from(elms_9)),
                            }))))) : singleton(defaultOf())), delay(() => {
                                let elms_11, elms_10;
                                return singleton((elms_11 = ofArray([createElement("label", {
                                    className: "label",
                                    children: "Comment",
                                }), (elms_10 = singleton_1(createElement("textarea", createObj(Helpers_combineClasses("textarea", ofArray([["onChange", (ev_2) => {
                                    patternInput_2[1](ev_2.target.value);
                                }], ["defaultValue", comment]]))))), createElement("div", {
                                    className: "control",
                                    children: reactApi.Children.toArray(Array.from(elms_10)),
                                }))]), createElement("div", {
                                    className: "field",
                                    children: reactApi.Children.toArray(Array.from(elms_11)),
                                })));
                            }));
                        }));
                    }));
                }));
            }));
        })), react.createElement(react.Fragment, {}, ...xs_32)),
        submit: create_1,
        submitText: "Create",
        tasks: patternInput[0],
        title: (categoryOpt != null) ? (`Create New ${EPM_Domain_Events_Action_Category__Category_ToProperString(categoryOpt)}`) : "Create New Activity",
    });
}

export function Update(updateInputProps) {
    let xs_10, elms_1, elms, elms_3, elms_2;
    const close = updateInputProps.close;
    const activity = updateInputProps.activity;
    const projectId = updateInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    let patternInput_1;
    const initial = defaultArg(activity.Name, "");
    patternInput_1 = reactApi.useState(initial);
    const name = patternInput_1[0];
    let patternInput_2;
    const initial_1 = defaultArg(activity.Detail, "");
    patternInput_2 = reactApi.useState(initial_1);
    const detail = patternInput_2[0];
    let updates;
    const dependencies_1 = [name, detail];
    updates = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (isNullOrWhiteSpace(name)) {
                return Promise.resolve();
            }
            else {
                const taskId = newGuid();
                taskDispatch(new TaskMsg(0, [taskId, `Update ${name}`]));
                const update = new Activities_UpdateActivity(name, System_String__String_ToOption_Static_Z721C83C5(detail));
                taskDispatch(new TaskMsg(2, [taskId]));
                return update_1(projectId, activity.Id, update).then((_arg) => {
                    const result = _arg;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(6, [taskId, result.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [taskId, undefined]));
                        return Promise.resolve();
                    }
                });
            }
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_10 = [(elms_1 = ofArray([createElement("label", {
            className: "label",
            children: "Name",
        }), (elms = singleton_1(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
            patternInput_1[1](ev.target.value);
        }], ["defaultValue", name]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        })), (elms_3 = ofArray([createElement("label", {
            className: "label",
            children: "Detail",
        }), (elms_2 = singleton_1(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev_1) => {
            patternInput_2[1](ev_1.target.value);
        }], ["defaultValue", detail]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_3)),
        }))], react.createElement(react.Fragment, {}, ...xs_10)),
        submit: updates,
        submitText: "Update",
        tasks: patternInput[0],
        title: "Update",
    });
}

export function AssignUser(assignUserInputProps) {
    let xs_2, elms;
    const close = assignUserInputProps.close;
    const activities = assignUserInputProps.activities;
    const projectId = assignUserInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const userOpt = patternInput_1[0];
    let initialUser;
    const dependencies_1 = [activities];
    initialUser = reactApi.useMemo(() => {
        const users = choose((m) => m.AssignedToUserId, activities);
        if (length(List_groupBy((x) => x, users, {
            Equals: (x_1, y) => (x_1 === y),
            GetHashCode: stringHash,
        })) > 1) {
            return undefined;
        }
        else {
            return tryHead(users);
        }
    }, dependencies_1);
    let assignUser;
    const dependencies_1_1 = [userOpt];
    assignUser = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (userOpt == null) {
                return Promise.resolve();
            }
            else {
                const user = userOpt;
                const assign = new Activities_AssignUser(user.Id);
                return PromiseBuilder__For_1565554B(promise, activities, (_arg) => {
                    const activity = _arg;
                    taskDispatch(new TaskMsg(0, [activity.Id, `Assign ${user.Name}`]));
                    taskDispatch(new TaskMsg(2, [activity.Id]));
                    return assignUser_1(projectId, activity.Id, assign).then((_arg_1) => {
                        const result = _arg_1;
                        if (result.tag === 1) {
                            taskDispatch(new TaskMsg(6, [activity.Id, result.fields[0]]));
                            return Promise.resolve();
                        }
                        else {
                            taskDispatch(new TaskMsg(3, [activity.Id, undefined]));
                            return Promise.resolve();
                        }
                    });
                });
            }
        }));
        void pr;
    }, dependencies_1_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_2 = [(elms = ofArray([createElement("label", {
            className: "label",
            children: "User",
        }), createElement(UserSelector_UserSelector, {
            projectId: projectId,
            initialUser: unwrap(initialUser),
            onSelectedUserChange: patternInput_1[1],
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))], react.createElement(react.Fragment, {}, ...xs_2)),
        submit: assignUser,
        submitText: "Assign",
        tasks: patternInput[0],
        title: "Assign User",
    });
}

export function SetExpectedDate(setExpectedDateInputProps) {
    let dependencies_1, elms, value_7;
    const close = setExpectedDateInputProps.close;
    const activities = setExpectedDateInputProps.activities;
    const projectId = setExpectedDateInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    let patternInput_1;
    const initial = defaultArg((dependencies_1 = [activities], reactApi.useMemo(() => {
        const dates = choose((m) => m.ExpectedCompletionDate, activities);
        if (length(List_groupBy((x) => x, dates, {
            Equals: equals,
            GetHashCode: dateHash,
        })) > 1) {
            return undefined;
        }
        else {
            return map(date_1, tryHead(dates));
        }
    }, dependencies_1)), utcNow());
    patternInput_1 = reactApi.useState(initial);
    const date = patternInput_1[0];
    let setExpectedDate;
    const dependencies_1_1 = [date];
    setExpectedDate = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            const exectedDate = new Activities_ExpectedCompletionDate(fromDate(date));
            return PromiseBuilder__For_1565554B(promise, activities, (_arg) => {
                const activity = _arg;
                taskDispatch(new TaskMsg(0, [activity.Id, `Set Expected Date To: ${toString(exectedDate)}`]));
                taskDispatch(new TaskMsg(2, [activity.Id]));
                return setExpectedDate_1(projectId, activity.Id, exectedDate).then((_arg_1) => {
                    const result = _arg_1;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(6, [activity.Id, result.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [activity.Id, undefined]));
                        return Promise.resolve();
                    }
                });
            });
        }));
        void pr;
    }, dependencies_1_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (elms = ofArray([createElement("label", {
            className: "label",
            children: "Expected Date",
        }), createElement("input", createObj(cons(["type", "date"], Helpers_combineClasses("input", ofArray([(value_7 = date, ["value", toString_1(value_7, "yyyy-MM-dd")]), ["onChange", (ev) => {
            iterate(patternInput_1[1], toArray(parse(ev.target.value)));
        }]])))))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms)),
        })),
        submit: setExpectedDate,
        submitText: "Set",
        tasks: patternInput[0],
        title: "Set Expected Date",
    });
}

export function SetEstimatedCompletionTime(setEstimatedCompletionTimeInputProps) {
    let dependencies_1, elms_1, elms;
    const close = setEstimatedCompletionTimeInputProps.close;
    const activities = setEstimatedCompletionTimeInputProps.activities;
    const projectId = setEstimatedCompletionTimeInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    let patternInput_1;
    const initial = defaultArg((dependencies_1 = [activities], reactApi.useMemo(() => {
        const times = choose((m) => m.EstimatedCompletionTime, activities);
        if (length(List_groupBy((x) => x, times, {
            Equals: (x_1, y) => (x_1 === y),
            GetHashCode: numberHash,
        })) > 1) {
            return undefined;
        }
        else {
            return map(totalHours, tryHead(times));
        }
    }, dependencies_1)), 0);
    patternInput_1 = reactApi.useState(initial);
    const hours = patternInput_1[0];
    let setEstimatedTime;
    const dependencies_1_1 = [hours];
    setEstimatedTime = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            const estimatedTime = new Activities_CompletionTime(fromHours(hours));
            return PromiseBuilder__For_1565554B(promise, activities, (_arg) => {
                const activity = _arg;
                taskDispatch(new TaskMsg(0, [activity.Id, `Set Estimated Time to : ${totalHours(estimatedTime.Time)} hours`]));
                taskDispatch(new TaskMsg(2, [activity.Id]));
                return setEstimatedTime_1(projectId, activity.Id, estimatedTime).then((_arg_1) => {
                    const result = _arg_1;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(6, [activity.Id, result.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [activity.Id, undefined]));
                        return Promise.resolve();
                    }
                });
            });
        }));
        void pr;
    }, dependencies_1_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (elms_1 = ofArray([createElement("label", {
            className: "label",
            children: "Hours",
        }), (elms = singleton_1(createElement("input", createObj(cons(["type", "number"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
            const value_6 = ev.target.valueAsNumber;
            if (!(value_6 == null) && !Number.isNaN(value_6)) {
                patternInput_1[1](value_6);
            }
        }], ["min", 0], ["defaultValue", hours]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        })),
        submit: setEstimatedTime,
        submitText: "Set",
        tasks: patternInput[0],
        title: "Set Estimated Time",
    });
}

export function SetActualCompletionTime(setActualCompletionTimeInputProps) {
    let dependencies_1, elms_1, elms;
    const close = setActualCompletionTimeInputProps.close;
    const activities = setActualCompletionTimeInputProps.activities;
    const projectId = setActualCompletionTimeInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    let patternInput_1;
    const initial = defaultArg((dependencies_1 = [activities], reactApi.useMemo(() => {
        const times = choose((m) => m.ActualCompletionTime, activities);
        if (length(List_groupBy((x) => x, times, {
            Equals: (x_1, y) => (x_1 === y),
            GetHashCode: numberHash,
        })) > 1) {
            return undefined;
        }
        else {
            return map(totalHours, tryHead(times));
        }
    }, dependencies_1)), 0);
    patternInput_1 = reactApi.useState(initial);
    const hours = patternInput_1[0];
    let setActualTime;
    const dependencies_1_1 = [hours];
    setActualTime = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            const actualTime = new Activities_CompletionTime(fromHours(hours));
            return PromiseBuilder__For_1565554B(promise, activities, (_arg) => {
                const activity = _arg;
                taskDispatch(new TaskMsg(0, [activity.Id, `Set Actual Time to : ${totalHours(actualTime.Time)} hours`]));
                taskDispatch(new TaskMsg(2, [activity.Id]));
                return setActualTime_1(projectId, activity.Id, actualTime).then((_arg_1) => {
                    const result = _arg_1;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(6, [activity.Id, result.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [activity.Id, undefined]));
                        return Promise.resolve();
                    }
                });
            });
        }));
        void pr;
    }, dependencies_1_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (elms_1 = ofArray([createElement("label", {
            className: "label",
            children: "Hours",
        }), (elms = singleton_1(createElement("input", createObj(cons(["type", "number"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
            const value_6 = ev.target.valueAsNumber;
            if (!(value_6 == null) && !Number.isNaN(value_6)) {
                patternInput_1[1](value_6);
            }
        }], ["min", 0], ["defaultValue", hours]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        })),
        submit: setActualTime,
        submitText: "Set",
        tasks: patternInput[0],
        title: "Set Actual Time",
    });
}

export function UnSign(unSignInputProps) {
    let elms_1, elms;
    const close = unSignInputProps.close;
    const activities = unSignInputProps.activities;
    const projectId = unSignInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState("");
    const reason = patternInput_1[0];
    let unsign_1;
    const dependencies_1 = [reason];
    unsign_1 = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let unsign;
            const Reason = isNullOrWhiteSpace(reason) ? undefined : reason;
            unsign = (new Activities_UnSigned(utcNow_1(), undefined, Reason));
            return PromiseBuilder__For_1565554B(promise, activities, (_arg) => {
                const activity = _arg;
                taskDispatch(new TaskMsg(0, [activity.Id, "Unsign"]));
                taskDispatch(new TaskMsg(2, [activity.Id]));
                const newUnsign = new Activities_UnSigned(unsign.On, tryHead(map_1((s) => s.SignedBy, activity.Signatories)), unsign.Reason);
                return unsign_2(projectId, activity.Id, newUnsign).then((_arg_1) => {
                    const result = _arg_1;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(6, [activity.Id, result.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [activity.Id, undefined]));
                        return Promise.resolve();
                    }
                });
            });
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (elms_1 = ofArray([createElement("label", {
            className: "label",
            children: "Reason",
        }), (elms = singleton_1(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
            patternInput_1[1](ev.target.value);
        }], ["defaultValue", reason]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        })),
        submit: unsign_1,
        submitText: "Unsign",
        tasks: patternInput[0],
        title: "Unsign",
    });
}

export function SignOff(signOffInputProps) {
    let xs_19;
    const close = signOffInputProps.close;
    const actionOpt = signOffInputProps.actionOpt;
    const activityName = signOffInputProps.activityName;
    const activityId = signOffInputProps.activityId;
    const projectId = signOffInputProps.projectId;
    const patternInput = reactApi.useState(false);
    const setDisabled = patternInput[1];
    const disabled = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const activityOpt = Fetched$1_toOption_50D43789(useFeliz_React__React_useFetch_Static_6ADA66EC((activityId_1) => single(projectId, activityId_1), activityId, [activityId]));
    const target = useFeliz_React__React_useOptionalFetch_Static_5B82200F((tupledArg) => targetEntity(projectId, tupledArg[0], tupledArg[1]), bind((activity) => map((te) => [te.EntityType, te.EntityId], activity.TargetEntity), activityOpt), [projectId, activityOpt]);
    const targetOpt = (target.tag === 2) ? target.fields[0] : undefined;
    const targetId_1 = map(Target__get_Id, targetOpt);
    const patternInput_2 = reactApi.useState(true);
    const uploadModeIsExistingDoc = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const setError_1 = patternInput_3[1];
    const patternInput_4 = reactApi.useState(empty_2());
    const existingDocuments = patternInput_4[0];
    const patternInput_5 = reactApi.useState(empty_2());
    const setFiles = patternInput_5[1];
    const files = patternInput_5[0];
    const initialDocs = reactApi.useMemo(empty_2, []);
    const patternInput_6 = reactApi.useState(false);
    const setIsDrag = patternInput_6[1];
    let signOff_1;
    const dependencies_1_1 = [existingDocuments, files, uploadModeIsExistingDoc, targetId_1, actionOpt];
    signOff_1 = reactApi.useCallback(() => {
        const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            setError_1(undefined);
            setDisabled(true);
            const signOff = new Activities_Signed(utcNow_1(), undefined);
            return signOff_2(projectId, activityId, signOff).then((_arg) => {
                let pr;
                const result = _arg;
                const existingDocs = choose((ed) => {
                    if (ed.tag === 9) {
                        return ed.fields[0];
                    }
                    else {
                        return undefined;
                    }
                }, existingDocuments);
                return ((pr = map_1((doc) => changeReferences(projectId, doc.Id, new Documents_ChangeReferences(FSharpMap__Add(doc.References, new DomainEntities(5, []), add(activityId, defaultArg(FSharpMap__TryFind(doc.References, new DomainEntities(5, [])), empty_3({
                    Compare: comparePrimitives,
                })))))), existingDocs), Promise.all(pr))).then((_arg_1) => {
                    let pr_1;
                    return ((pr_1 = map_1((file) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let action_1, activityName_2, activityName_1, action;
                        const targetName = defaultArg(map(Target__get_Name, targetOpt), "Unknown Target Entity");
                        const createDoc = new Documents_CreateDocument((activityName != null) ? ((actionOpt != null) ? ((action_1 = actionOpt, (activityName_2 = activityName, `${action_1.Name} - ${activityName_2} - ${targetName} - ${file.name}`))) : ((activityName_1 = activityName, `${activityName_1} - ${targetName} - ${file.name}`))) : ((actionOpt != null) ? ((action = actionOpt, `${action.Name} - ${targetName} - ${file.name}`)) : (`${file.name}-Evidence: ActivityId: ${activityId}`)), file.name, empty({
                            Compare: comparePrimitives,
                        }), ofList(singleton_1([new DomainEntities(5, []), ofList_1(singleton_1(activityId), {
                            Compare: comparePrimitives,
                        })]), {
                            Compare: compare,
                        }), undefined);
                        return createUpload(projectId, createDoc, file).then((_arg_2) => (Promise.resolve(undefined)));
                    })), files), Promise.all(pr_1))).then((_arg_3) => {
                        setDisabled(false);
                        if (result.tag === 1) {
                            setError_1(result.fields[0]);
                            return Promise.resolve();
                        }
                        else {
                            close(true);
                            return Promise.resolve();
                        }
                    });
                });
            });
        }));
        void pr_2;
    }, dependencies_1_1);
    return createElement(Modal_ModalWithFooter, {
        close: () => {
            close(false);
        },
        content: (xs_19 = toList(delay(() => {
            let matchValue_1, e;
            return append((matchValue_1 = patternInput_3[0], (matchValue_1 == null) ? (empty_1()) : ((e = matchValue_1, (console.error(some(e)), singleton(createElement(Components_FetchErrorNotification, {
                error: e,
            })))))), delay(() => append(singleton("Documents uploaded will be referenced against this activity"), delay(() => {
                let elms, elems;
                return append(singleton((elms = ofArray([createElement("label", {
                    className: "label",
                    children: uploadModeIsExistingDoc ? "Choose Existing Docs" : "Upload New Docs",
                }), createElement("div", createObj(Helpers_combineClasses("control", ofArray([["className", join(" ", ["description-toggle", "pretty", "p-switch", "p-fill"])], (elems = [createElement("input", {
                    type: "checkbox",
                    defaultChecked: uploadModeIsExistingDoc,
                    onClick: (_arg_4) => {
                        patternInput_2[1](!uploadModeIsExistingDoc);
                    },
                }), createElement("div", {
                    className: "state",
                    children: createElement("label", {}),
                })], ["children", reactApi.Children.toArray(Array.from(elems))])]))))]), createElement("div", {
                    className: "field",
                    children: reactApi.Children.toArray(Array.from(elms)),
                }))), delay(() => {
                    let elms_4;
                    return append(uploadModeIsExistingDoc ? singleton(createElement(DomainEntitiesSelector, {
                        projectId: projectId,
                        entityType: documentEntityType,
                        initialEntities: initialDocs,
                        onSelectedEntitiesChange: patternInput_4[1],
                        filters: empty_2(),
                        isSmall: false,
                    })) : singleton((elms_4 = singleton_1(createElement("div", createObj(Helpers_combineClasses("file", toList(delay(() => append(singleton(["className", "is-boxed"]), delay(() => append(singleton(["className", "has-name"]), delay(() => append(patternInput_6[0] ? singleton(["className", "is-warning"]) : singleton(["className", "is-info"]), delay(() => {
                        let elems_6, elems_5, elms_3;
                        return singleton((elems_6 = [createElement("div", createObj(ofArray([["onDragEnter", (_arg_5) => {
                            setIsDrag(true);
                        }], ["onDragLeave", (_arg_6) => {
                            setIsDrag(false);
                        }], ["onDragOver", (e_1) => {
                            e_1.preventDefault();
                            setIsDrag(true);
                        }], ["onDrop", (e_2) => {
                            let list_3, objectArg;
                            e_2.preventDefault();
                            setFiles((list_3 = toList(rangeDouble(0, 1, e_2.dataTransfer.files.length - 1)), map_1((objectArg = e_2.dataTransfer.files, (index) => (objectArg[index])), list_3)));
                            setIsDrag(false);
                        }], (elems_5 = [(elms_3 = toList(delay(() => append(singleton(createElement("input", createObj(cons(["type", "file"], Helpers_combineClasses("file-input", ofArray([["type", "file"], ["multiple", true], ["onChange", (ev) => {
                            const fileList = ev.target.files;
                            if (!(fileList == null)) {
                                setFiles(toList(delay(() => map_2((i) => fileList.item(i), rangeDouble(0, 1, fileList.length - 1)))));
                            }
                        }]])))))), delay(() => {
                            let elms_2, elms_1;
                            return append(singleton((elms_2 = ofArray([(elms_1 = singleton_1(Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-file-upload"])), [])), createElement("span", {
                                className: "file-icon",
                                children: reactApi.Children.toArray(Array.from(elms_1)),
                            })), createElement("span", {
                                className: "file-label",
                                children: "Choose Documents...",
                            })]), createElement("span", {
                                className: "file-cta",
                                children: reactApi.Children.toArray(Array.from(elms_2)),
                            }))), delay(() => {
                                const matchValue_2 = files;
                                let matchResult, file_1;
                                if (!isEmpty(matchValue_2)) {
                                    if (isEmpty(tail(matchValue_2))) {
                                        matchResult = 0;
                                        file_1 = head(matchValue_2);
                                    }
                                    else {
                                        matchResult = 1;
                                    }
                                }
                                else {
                                    matchResult = 1;
                                }
                                switch (matchResult) {
                                    case 0:
                                        return singleton(createElement("span", {
                                            className: "file-name",
                                            children: file_1.name,
                                        }));
                                    default:
                                        return singleton(createElement("span", {
                                            className: "file-name",
                                            children: `${length(files)} documents`,
                                        }));
                                }
                            }));
                        })))), createElement("label", {
                            className: "file-label",
                            children: reactApi.Children.toArray(Array.from(elms_3)),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))]));
                    })))))))))))), createElement("div", {
                        className: "field",
                        children: reactApi.Children.toArray(Array.from(elms_4)),
                    }))), delay(() => singleton("This step will be completed as you")));
                }));
            }))));
        })), react.createElement(react.Fragment, {}, ...xs_19)),
        disabled: disabled,
        footer: singleton_1(createElement("button", createObj(Helpers_combineClasses("button", toList(delay(() => append(singleton(["children", "Sign"]), delay(() => append(singleton(["className", "is-small"]), delay(() => append(singleton(["className", "is-success"]), delay(() => append(singleton(["disabled", disabled]), delay(() => append(disabled ? singleton(["className", "is-loading"]) : empty_1(), delay(() => singleton(["onClick", (_arg_7) => {
            signOff_1();
        }]))))))))))))))))),
        title: `Sign Off: ${defaultArg(orElse(map((action_2) => action_2.Name, actionOpt), activityName), "Unknown")}`,
    });
}

const exportHeaders = ofArray([{
    key: "id",
    name: "Id",
}, {
    key: "actionId",
    name: "ActionId",
}, {
    key: "name",
    name: "Name",
}, {
    key: "detail",
    name: "Detail",
}, {
    key: "category",
    name: "Category",
}, {
    key: "maturity",
    name: "Maturity",
}, {
    key: "actionName",
    name: "ActionName",
}, {
    key: "actionDetail",
    name: "ActionDetail",
}, {
    key: "type",
    name: "Type",
}, {
    key: "entityId",
    name: "EntityId",
}, {
    key: "entityType",
    name: "EntityType",
}, {
    key: "entityName",
    name: "EntityName",
}, {
    key: "entityDetail",
    name: "EntityDetail",
}, {
    key: "estimatedCompletionTime",
    name: "EstimatedCompletionTime",
}, {
    key: "actualCompletionTime",
    name: "ActualCompletionTime",
}, {
    key: "expectedCompletionDate",
    name: "ExpectedCompletionDate",
}, {
    key: "completedOn",
    name: "CompletedOn",
}, {
    key: "equipmentTypeId",
    name: "EquipmentTypeId",
}, {
    key: "equipmentTypeName",
    name: "EquipmentTypeName",
}, {
    key: "discplineId",
    name: "DiscplineId",
}, {
    key: "discplineName",
    name: "DiscplineName",
}, {
    key: "sourceDocumentId",
    name: "SourceDocumentId",
}, {
    key: "sourceDocumentName",
    name: "SourceDocumentName",
}, {
    key: "productionUnitTypeId",
    name: "ProductionUnitTypeId",
}, {
    key: "productionUnitTypeName",
    name: "ProductionUnitTypeName",
}, {
    key: "productionUnitId",
    name: "ProductionUnitId",
}, {
    key: "productionUnitName",
    name: "ProductionUnitName",
}, {
    key: "systemId",
    name: "SystemId",
}, {
    key: "systemName",
    name: "SystemName",
}, {
    key: "systemDetail",
    name: "SystemDetail",
}, {
    key: "subsystemId",
    name: "SubsystemId",
}, {
    key: "subsystemName",
    name: "SubsystemName",
}, {
    key: "subsystemDetail",
    name: "SubsystemDetail",
}, {
    key: "facilityId",
    name: "FacilityId",
}, {
    key: "facilityName",
    name: "FacilityName",
}, {
    key: "moduleId",
    name: "ModuleId",
}, {
    key: "moduleName",
    name: "ModuleName",
}, {
    key: "areaId",
    name: "AreaId",
}, {
    key: "areaName",
    name: "AreaName",
}, {
    key: "locationId",
    name: "LocationId",
}, {
    key: "locationName",
    name: "LocationName",
}, {
    key: "qrCode",
    name: "QRCode",
}, {
    key: "deletedOn",
    name: "DeletedOn",
}]);

function exportActivity(activity, projectId) {
    let list_6, list_4, list_2;
    return ofList((list_6 = ((list_4 = ((list_2 = choose((x) => x, ofArray([map((e) => ["deletedOn", toString_1(e, "O")], activity.DeletedOn), map((a) => ["actionName", a], activity.ActionName), map((a_1) => ["actionDetail", a_1], activity.ActionDetail), map((a_2) => ["name", a_2], activity.ActivityName), map((a_3) => ["detail", a_3], activity.ActivityDetail), map((a_4) => ["category", toString(a_4)], activity.ActivityCategory), map((a_5) => ["type", toString(a_5)], activity.Category), map((a_6) => ["maturity", toString(a_6)], activity.Maturity), map((a_7) => ["actionId", a_7], activity.ActionId), map((te) => ["entityId", te], activity.EntityId), map((te_1) => ["entityType", toString(te_1)], activity.EntityType), map((te_2) => ["entityName", te_2], activity.EntityName), map((te_3) => ["entityDetail", te_3], activity.EntityDetail), map((t) => {
        let copyOfStruct;
        return ["estimatedCompletionTime", (copyOfStruct = totalHours(t), copyOfStruct.toString())];
    }, activity.EstimatedCompletionTime), map((t_1) => {
        let copyOfStruct_1;
        return ["actualCompletionTime", (copyOfStruct_1 = totalHours(t_1), copyOfStruct_1.toString())];
    }, activity.ActualCompletionTime), map((t_2) => ["expectedCompletionDate", toString_1(t_2, "O")], activity.ExpectedCompletionDate), map((t_3) => ["completedOn", toString_1(t_3, "O")], activity.CompletedOn), map((e_1) => ["productionUnitTypeId", e_1], activity.ProductionUnitTypeId), map((e_2) => ["productionUnitTypeName", e_2], activity.ProdductionUnitTypeName), map((e_3) => ["productionUnitId", e_3], activity.ProductionUnitId), map((e_4) => ["productionUnitName", e_4], activity.ProductionUnitName), map((e_5) => ["systemId", e_5], activity.SystemId), map((e_6) => ["systemName", e_6], activity.SystemName), map((e_7) => ["systemDetail", e_7], activity.SystemDetail), map((e_8) => ["subsystemId", e_8], activity.SubsystemId), map((e_9) => ["subsystemName", e_9], activity.SubsystemName), map((e_10) => ["subsystemDetail", e_10], activity.SubsystemDetail), map((e_11) => ["facilityId", e_11], activity.FacilityId), map((e_12) => ["facilityName", e_12], activity.FacilityName), map((e_13) => ["moduleId", e_13], activity.ModuleId), map((e_14) => ["moduleName", e_14], activity.ModuleName), map((e_15) => ["areaId", e_15], activity.AreaId), map((e_16) => ["areaName", e_16], activity.AreaName), map((e_17) => ["locationId", e_17], activity.LocationId), map((e_18) => ["locationName", e_18], activity.LocationName), map((e_19) => ["equipmentTypeId", e_19], activity.EquipmentTypeId), map((e_20) => ["equipmentTypeName", e_20], activity.EquipmentTypeName), map((e_21) => ["discplineId", e_21], activity.DisciplineId), map((e_22) => ["discplineName", e_22], activity.DisciplineName), map((e_23) => ["sourceDocumentId", e_23], activity.SourceDocumentId), map((e_24) => ["sourceDocumentName", e_24], activity.SourceDocumentName)])), append_1(ofArray([["id", activity.Id], ["qrCode", ProjectPage_CreateQRCodeUrl(projectId, new DomainEntities(5, []), activity.Id)]]), list_2))), append_1(ofSeq(collect((kv) => collect((x_1) => x_1, mapIndexed((i, v) => singleton_1([`Label:${kv[0]}:${i}`, v]), kv[1])), activity.Labels)), list_4))), append_1(ofSeq(collect((x_2) => x_2, map_2((kv_1) => singleton_1([`Attribute:${kv_1[0]}`, EPM_Domain_Events_Attribute__Attribute_ValueString(kv_1[1])]), activity.Attributes))), list_6)), {
        Compare: comparePrimitives,
    });
}

function downloadCSV(setProcessing, setTotal, setFetched, projectId, filters) {
    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        setProcessing(true);
        return count(projectId, filters).then((_arg) => {
            let initialCount, chunks;
            const initialCountResult = _arg;
            let results = empty_2();
            let labelHeaders = empty_3({
                Compare: compare,
            });
            let attributeHeaders = empty_3({
                Compare: compare,
            });
            let hasSeen = empty_3({
                Compare: comparePrimitives,
            });
            return ((initialCountResult.tag === 0) ? ((initialCount = (initialCountResult.fields[0] | 0), (setTotal(initialCount), (chunks = ((~~(initialCount / 5000) + (((initialCount % 5000) > 0) ? 1 : 0)) | 0), PromiseBuilder__For_1565554B(promise, rangeDouble(0, 1, chunks - 1), (_arg_1) => {
                const apiParams = ofArray([["fetch", int32ToString(5000)], ["offset", int32ToString(_arg_1 * 5000)]]);
                return export$(projectId, apiParams, filters).then((_arg_2) => {
                    const dataResult = _arg_2;
                    if (dataResult.tag === 0) {
                        return PromiseBuilder__For_1565554B(promise, dataResult.fields[0], (_arg_3) => {
                            const activity = _arg_3;
                            if (FSharpSet__Contains(hasSeen, activity.Id)) {
                                return Promise.resolve();
                            }
                            else {
                                hasSeen = add(activity.Id, hasSeen);
                                const activityLabelHeaders = ofSeq_1(collect((tupledArg) => {
                                    const key = tupledArg[0];
                                    return map_1((n_1) => ({
                                        key: `Label:${key}:${n_1}`,
                                        name: `Label:${key}`,
                                    }), toList(rangeDouble(0, 1, length_1(tupledArg[1]) - 1)));
                                }, groupBy((x_3) => x_3, map_2((kv) => kv[0], activity.Labels), {
                                    Equals: (x_4, y_3) => (x_4 === y_3),
                                    GetHashCode: stringHash,
                                })), {
                                    Compare: compare,
                                });
                                labelHeaders = union(labelHeaders, activityLabelHeaders);
                                const activityAttributeHeaders = ofSeq_1(map_2((kv_1) => ({
                                    key: `Attribute:${kv_1[0]}`,
                                    name: `Attribute:${kv_1[0]}`,
                                }), activity.Attributes), {
                                    Compare: compare,
                                });
                                attributeHeaders = union(attributeHeaders, activityAttributeHeaders);
                                const processedData = exportActivity(activity, projectId);
                                results = cons(processedData, results);
                                setFetched(length(results));
                                return Promise.resolve();
                            }
                        });
                    }
                    else {
                        console.error(some(dataResult.fields[0]));
                        return Promise.resolve();
                    }
                });
            }).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let source_4;
                const processedData_1 = reverse(results);
                const headers = ofSeq(append(exportHeaders, (source_4 = attributeHeaders, append(labelHeaders, source_4))));
                const csv = StringBuilder_$ctor();
                StringBuilder__AppendLine_Z721C83C5(csv, join(",", map_1((header) => Csv_encode(header.name), headers)));
                iterate_1((arg) => {
                    StringBuilder__AppendLine_Z721C83C5(csv, arg);
                }, map_1((data) => join(",", map_1((header_1) => defaultArg(map(Csv_encode, FSharpMap__TryFind(data, header_1.key)), ""), headers)), processedData_1));
                const content = toString(csv);
                const now = toString_1(utcNow(), "yyyy-MM-dd hh:mm:ss");
                file_saver(new Blob([content], { 'type': "text/csv" }), `activity-export-${now}.csv`);
                return Promise.resolve();
            })))))) : ((console.error(some(initialCountResult.fields[0])), Promise.resolve()))).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => {
                setProcessing(false);
                return Promise.resolve();
            }));
        });
    }));
    void pr;
}

export function Export(exportInputProps) {
    const close = exportInputProps.close;
    const filters = exportInputProps.filters;
    const projectId = exportInputProps.projectId;
    const patternInput = reactApi.useState(0);
    const total = patternInput[0] | 0;
    const patternInput_1 = reactApi.useState(0);
    const fetched = patternInput_1[0] | 0;
    const patternInput_2 = reactApi.useState(false);
    const processing = patternInput_2[0];
    return createElement(Modal_ModalWithFooter, {
        close: close,
        content: createElement("progress", createObj(Helpers_combineClasses("progress", ofArray([["className", "is-primary"], ["max", total], ["value", fetched], ["title", toText(interpolate("%.2f%P()%%", [(total === 0) ? 0 : ((fetched / total) * 100)]))]])))),
        disabled: processing,
        footer: singleton_1(createElement("button", createObj(Helpers_combineClasses("button", toList(delay(() => append(processing ? singleton(["className", "is-loading"]) : empty_1(), delay(() => append(singleton(["disabled", processing]), delay(() => append(singleton(["children", "Download"]), delay(() => singleton(["onClick", (_arg) => {
            downloadCSV(patternInput_2[1], patternInput[1], patternInput_1[1], projectId, filters);
        }]))))))))))))),
        title: "Export as CSV",
    });
}

export function RevertStep(revertStepInputProps) {
    let xs;
    const close = revertStepInputProps.close;
    const actionStep = revertStepInputProps.actionStep;
    const activityId = revertStepInputProps.activityId;
    const projectId = revertStepInputProps.projectId;
    const patternInput = reactApi.useState(false);
    const setDisabled = patternInput[1];
    const disabled = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setError = patternInput_1[1];
    const revert = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            setError(undefined);
            setDisabled(true);
            const revertStep = new Activities_RevertActivityStep(actionStep.Id, undefined, undefined);
            return revertStep_1(projectId, activityId, revertStep).then((_arg) => {
                const result = _arg;
                setDisabled(false);
                if (result.tag === 1) {
                    setError(result.fields[0]);
                    return Promise.resolve();
                }
                else {
                    close(true);
                    return Promise.resolve();
                }
            });
        }));
        void pr;
    }, []);
    return createElement(Modal_ModalWithFooter, {
        close: () => {
            close(false);
        },
        content: (xs = toList(delay(() => {
            let matchValue, e;
            return append((matchValue = patternInput_1[0], (matchValue == null) ? (empty_1()) : ((e = matchValue, (console.error(some(e)), singleton(createElement(Components_FetchErrorNotification, {
                error: e,
            })))))), delay(() => singleton("This completed step will be reverted as you")));
        })), react.createElement(react.Fragment, {}, ...xs)),
        disabled: disabled,
        footer: singleton_1(createElement("button", createObj(Helpers_combineClasses("button", toList(delay(() => append(singleton(["children", "Revert"]), delay(() => append(singleton(["className", "is-small"]), delay(() => append(singleton(["className", "is-success"]), delay(() => append(singleton(["disabled", disabled]), delay(() => append(disabled ? singleton(["className", "is-loading"]) : empty_1(), delay(() => singleton(["onClick", (_arg_1) => {
            revert();
        }]))))))))))))))))),
        title: `Revert: ${actionStep.Name}`,
    });
}

export function CompleteSignOffStep(completeSignOffStepInputProps) {
    let xs;
    const close = completeSignOffStepInputProps.close;
    const actionStep = completeSignOffStepInputProps.actionStep;
    const activityId = completeSignOffStepInputProps.activityId;
    const stepIndex = completeSignOffStepInputProps.stepIndex;
    const projectId = completeSignOffStepInputProps.projectId;
    const patternInput = reactApi.useState(false);
    const setDisabled = patternInput[1];
    const disabled = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setError = patternInput_1[1];
    const complete = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            setError(undefined);
            setDisabled(true);
            const completeStep = new Activities_CompleteActivityStep(actionStep.Id, undefined, undefined, new Activities_EvidenceType(0, []), undefined);
            return completeStep_1(projectId, activityId, completeStep).then((_arg) => {
                const result = _arg;
                setDisabled(false);
                if (result.tag === 1) {
                    setError(result.fields[0]);
                    return Promise.resolve();
                }
                else {
                    close(true);
                    return Promise.resolve();
                }
            });
        }));
        void pr;
    }, []);
    return createElement(Modal_ModalWithFooter, {
        close: () => {
            close(false);
        },
        content: (xs = toList(delay(() => {
            let matchValue, e;
            return append((matchValue = patternInput_1[0], (matchValue == null) ? (empty_1()) : ((e = matchValue, (console.error(some(e)), singleton(createElement(Components_FetchErrorNotification, {
                error: e,
            })))))), delay(() => singleton("This step will be completed as you")));
        })), react.createElement(react.Fragment, {}, ...xs)),
        disabled: disabled,
        footer: singleton_1(createElement("button", createObj(Helpers_combineClasses("button", toList(delay(() => append(singleton(["children", "Complete"]), delay(() => append(singleton(["className", "is-small"]), delay(() => append(singleton(["className", "is-success"]), delay(() => append(singleton(["disabled", disabled]), delay(() => append(disabled ? singleton(["className", "is-loading"]) : empty_1(), delay(() => singleton(["onClick", (_arg_1) => {
            complete();
        }]))))))))))))))))),
        title: `Complete Step #${stepIndex}: ${actionStep.Name}`,
    });
}

export function CompleteNumberStep(completeNumberStepInputProps) {
    let xs_5;
    const close = completeNumberStepInputProps.close;
    const actionStep = completeNumberStepInputProps.actionStep;
    const activityId = completeNumberStepInputProps.activityId;
    const stepIndex = completeNumberStepInputProps.stepIndex;
    const projectId = completeNumberStepInputProps.projectId;
    const patternInput = reactApi.useState(false);
    const setDisabled = patternInput[1];
    const disabled = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setError = patternInput_1[1];
    const patternInput_2 = reactApi.useState(0);
    const number = patternInput_2[0];
    let complete;
    const dependencies_1 = [number];
    complete = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            setError(undefined);
            setDisabled(true);
            const completeStep = new Activities_CompleteActivityStep(actionStep.Id, undefined, undefined, new Activities_EvidenceType(3, [number]), undefined);
            return completeStep_1(projectId, activityId, completeStep).then((_arg) => {
                const result = _arg;
                setDisabled(false);
                if (result.tag === 1) {
                    setError(result.fields[0]);
                    return Promise.resolve();
                }
                else {
                    close(true);
                    return Promise.resolve();
                }
            });
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithFooter, {
        close: () => {
            close(false);
        },
        content: (xs_5 = toList(delay(() => {
            let matchValue, e;
            return append((matchValue = patternInput_1[0], (matchValue == null) ? (empty_1()) : ((e = matchValue, (console.error(some(e)), singleton(createElement(Components_FetchErrorNotification, {
                error: e,
            })))))), delay(() => {
                let elms;
                return append(singleton((elms = singleton_1(createElement("p", createObj(Helpers_combineClasses("control", ofArray([["className", "is-expanded"], ["children", createElement("input", createObj(cons(["type", "number"], Helpers_combineClasses("input", ofArray([["disabled", disabled], ["placeholder", "Add a number"], ["onChange", (ev) => {
                    const value_6 = ev.target.valueAsNumber;
                    if (!(value_6 == null) && !Number.isNaN(value_6)) {
                        patternInput_2[1](value_6);
                    }
                }]])))))]]))))), createElement("div", {
                    className: "field",
                    children: reactApi.Children.toArray(Array.from(elms)),
                }))), delay(() => singleton("This step will be completed as you")));
            }));
        })), react.createElement(react.Fragment, {}, ...xs_5)),
        disabled: disabled,
        footer: singleton_1(createElement("button", createObj(Helpers_combineClasses("button", toList(delay(() => append(singleton(["children", "Complete"]), delay(() => append(singleton(["className", "is-small"]), delay(() => append(singleton(["className", "is-success"]), delay(() => append(singleton(["disabled", disabled]), delay(() => append(disabled ? singleton(["className", "is-loading"]) : empty_1(), delay(() => singleton(["onClick", (_arg_1) => {
            complete();
        }]))))))))))))))))),
        title: `Complete Step #${stepIndex}: ${actionStep.Name}`,
    });
}

export function CompleteCommentStep(completeCommentStepInputProps) {
    let xs_5;
    const close = completeCommentStepInputProps.close;
    const actionStep = completeCommentStepInputProps.actionStep;
    const activityId = completeCommentStepInputProps.activityId;
    const stepIndex = completeCommentStepInputProps.stepIndex;
    const projectId = completeCommentStepInputProps.projectId;
    const patternInput = reactApi.useState(false);
    const setDisabled = patternInput[1];
    const disabled = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setError = patternInput_1[1];
    const patternInput_2 = reactApi.useState("");
    const comment = patternInput_2[0];
    let complete;
    const dependencies_1 = [comment];
    complete = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            setError(undefined);
            setDisabled(true);
            const completeStep = new Activities_CompleteActivityStep(actionStep.Id, undefined, undefined, new Activities_EvidenceType(2, [comment]), undefined);
            return completeStep_1(projectId, activityId, completeStep).then((_arg) => {
                const result = _arg;
                setDisabled(false);
                if (result.tag === 1) {
                    setError(result.fields[0]);
                    return Promise.resolve();
                }
                else {
                    close(true);
                    return Promise.resolve();
                }
            });
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithFooter, {
        close: () => {
            close(false);
        },
        content: (xs_5 = toList(delay(() => {
            let matchValue, e;
            return append((matchValue = patternInput_1[0], (matchValue == null) ? (empty_1()) : ((e = matchValue, (console.error(some(e)), singleton(createElement(Components_FetchErrorNotification, {
                error: e,
            })))))), delay(() => {
                let elms;
                return append(singleton((elms = singleton_1(createElement("p", createObj(Helpers_combineClasses("control", ofArray([["className", "is-expanded"], ["children", createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["disabled", disabled], ["placeholder", "Add a comment"], ["onChange", (ev) => {
                    patternInput_2[1](ev.target.value);
                }]])))))]]))))), createElement("div", {
                    className: "field",
                    children: reactApi.Children.toArray(Array.from(elms)),
                }))), delay(() => singleton("This step will be completed as you")));
            }));
        })), react.createElement(react.Fragment, {}, ...xs_5)),
        disabled: disabled,
        footer: singleton_1(createElement("button", createObj(Helpers_combineClasses("button", toList(delay(() => append(singleton(["children", "Complete"]), delay(() => append(singleton(["className", "is-small"]), delay(() => append(singleton(["className", "is-success"]), delay(() => append(singleton(["disabled", disabled]), delay(() => append(disabled ? singleton(["className", "is-loading"]) : empty_1(), delay(() => singleton(["onClick", (_arg_1) => {
            complete();
        }]))))))))))))))))),
        title: `Complete Step #${stepIndex}: ${actionStep.Name}`,
    });
}

export function CompleteDocumentStep(completeDocumentStepInputProps) {
    let xs_19;
    const close = completeDocumentStepInputProps.close;
    const actionStep = completeDocumentStepInputProps.actionStep;
    const activityId = completeDocumentStepInputProps.activityId;
    const stepIndex = completeDocumentStepInputProps.stepIndex;
    const projectId = completeDocumentStepInputProps.projectId;
    const patternInput = reactApi.useState(false);
    const setDisabled = patternInput[1];
    const disabled = patternInput[0];
    const patternInput_1 = reactApi.useState(true);
    const uploadModeIsExistingDoc = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const setError = patternInput_2[1];
    const patternInput_3 = reactApi.useState(empty_2());
    const existingDocuments = patternInput_3[0];
    const patternInput_4 = reactApi.useState(empty_2());
    const setFiles = patternInput_4[1];
    const files = patternInput_4[0];
    const initialDocs = reactApi.useMemo(empty_2, []);
    const patternInput_5 = reactApi.useState(false);
    const setIsDrag = patternInput_5[1];
    let complete;
    const dependencies_1_1 = [existingDocuments, files, uploadModeIsExistingDoc];
    complete = reactApi.useCallback(() => {
        const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let pr;
            setError(undefined);
            setDisabled(true);
            const existingDocs = choose((ed) => {
                if (ed.tag === 9) {
                    return ed.fields[0];
                }
                else {
                    return undefined;
                }
            }, existingDocuments);
            const existingDocumentEvidence = map_1((ed_1) => (new Activity_DocumentEvidence(ed_1.Id, ed_1.CurrentRevision.RevisionId)), existingDocs);
            return ((pr = map_1((file) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let attempts = 10;
                const docName = `${file.name}-Evidence: ActivityId: ${activityId}`;
                const createDoc = new Documents_CreateDocument(docName, file.name, empty({
                    Compare: comparePrimitives,
                }), ofList(singleton_1([new DomainEntities(5, []), ofList_1(singleton_1(activityId), {
                    Compare: comparePrimitives,
                })]), {
                    Compare: compare,
                }), undefined);
                return createUpload(projectId, createDoc, file).then((_arg) => {
                    let findNewDoc = undefined;
                    return PromiseBuilder__While_2044D34(promise, () => (attempts > 0), PromiseBuilder__Delay_62FBFDE1(promise, () => ((new Promise(resolve => setTimeout(resolve, 5000))).then(() => {
                        const apiDocParams = ofArray([["references", join(",", map_1((e) => e, singleton_1(activityId)))], ["name", docName]]);
                        const apiParams = singleton_1(["fetch", int32ToString(1)]);
                        return many(projectId, apiParams, apiDocParams).then((_arg_2) => {
                            const d_1 = _arg_2;
                            findNewDoc = d_1;
                            if (d_1.tag === 1) {
                                console.log(some("Couldn\'t find recently upload doc"), docName, d_1.fields[0]);
                                attempts = ((attempts - 1) | 0);
                                return Promise.resolve();
                            }
                            else if (length(d_1.fields[0]) > 0) {
                                attempts = 0;
                                return Promise.resolve();
                            }
                            else {
                                attempts = ((attempts - 1) | 0);
                                return Promise.resolve();
                            }
                        });
                    })))).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        if (findNewDoc == null) {
                            console.log(some("Couldn\'t find recently upload doc"), docName);
                            return Promise.resolve(undefined);
                        }
                        else {
                            const r = findNewDoc;
                            if (r.tag === 1) {
                                console.log(some("Couldn\'t find recently upload doc"), docName, r.fields[0]);
                                return Promise.resolve(undefined);
                            }
                            else {
                                return Promise.resolve(r.fields[0]);
                            }
                        }
                    }));
                });
            })), files), Promise.all(pr))).then((_arg_3) => {
                const completeStep = new Activities_CompleteActivityStep(actionStep.Id, undefined, undefined, new Activities_EvidenceType(1, [append_1(existingDocumentEvidence, map_1((ed_2) => (new Activity_DocumentEvidence(ed_2.Id, ed_2.CurrentRevision.RevisionId)), collect_1((x_4) => x_4, choose((x_3) => x_3, ofArray(_arg_3)))))]), undefined);
                return completeStep_1(projectId, activityId, completeStep).then((_arg_4) => {
                    let pr_1;
                    const result = _arg_4;
                    return ((pr_1 = map_1((doc_1) => changeReferences(projectId, doc_1.Id, new Documents_ChangeReferences(FSharpMap__Add(doc_1.References, new DomainEntities(5, []), add(activityId, defaultArg(FSharpMap__TryFind(doc_1.References, new DomainEntities(5, [])), empty_3({
                        Compare: comparePrimitives,
                    })))))), existingDocs), Promise.all(pr_1))).then((_arg_5) => {
                        setDisabled(false);
                        if (result.tag === 1) {
                            setError(result.fields[0]);
                            return Promise.resolve();
                        }
                        else {
                            close(true);
                            return Promise.resolve();
                        }
                    });
                });
            });
        }));
        void pr_2;
    }, dependencies_1_1);
    return createElement(Modal_ModalWithFooter, {
        close: () => {
            close(false);
        },
        content: (xs_19 = toList(delay(() => {
            let matchValue, e_3;
            return append((matchValue = patternInput_2[0], (matchValue == null) ? (empty_1()) : ((e_3 = matchValue, (console.error(some(e_3)), singleton(createElement(Components_FetchErrorNotification, {
                error: e_3,
            })))))), delay(() => {
                let elms, elems;
                return append(singleton((elms = ofArray([createElement("label", {
                    className: "label",
                    children: uploadModeIsExistingDoc ? "Choose Existing Docs" : "Upload New Docs",
                }), createElement("div", createObj(Helpers_combineClasses("control", ofArray([["className", join(" ", ["description-toggle", "pretty", "p-switch", "p-fill"])], (elems = [createElement("input", {
                    type: "checkbox",
                    defaultChecked: uploadModeIsExistingDoc,
                    onClick: (_arg_6) => {
                        patternInput_1[1](!uploadModeIsExistingDoc);
                    },
                }), createElement("div", {
                    className: "state",
                    children: createElement("label", {}),
                })], ["children", reactApi.Children.toArray(Array.from(elems))])]))))]), createElement("div", {
                    className: "field",
                    children: reactApi.Children.toArray(Array.from(elms)),
                }))), delay(() => {
                    let elms_4;
                    return append(uploadModeIsExistingDoc ? singleton(createElement(DomainEntitiesSelector, {
                        projectId: projectId,
                        entityType: documentEntityType,
                        initialEntities: initialDocs,
                        onSelectedEntitiesChange: patternInput_3[1],
                        filters: empty_2(),
                        isSmall: false,
                    })) : singleton((elms_4 = singleton_1(createElement("div", createObj(Helpers_combineClasses("file", toList(delay(() => append(singleton(["className", "is-boxed"]), delay(() => append(singleton(["className", "has-name"]), delay(() => append(patternInput_5[0] ? singleton(["className", "is-warning"]) : singleton(["className", "is-info"]), delay(() => {
                        let elems_6, elems_5, elms_3;
                        return singleton((elems_6 = [createElement("div", createObj(ofArray([["onDragEnter", (_arg_7) => {
                            setIsDrag(true);
                        }], ["onDragLeave", (_arg_8) => {
                            setIsDrag(false);
                        }], ["onDragOver", (e_4) => {
                            e_4.preventDefault();
                            setIsDrag(true);
                        }], ["onDrop", (e_5) => {
                            let list_8, objectArg;
                            e_5.preventDefault();
                            setFiles((list_8 = toList(rangeDouble(0, 1, e_5.dataTransfer.files.length - 1)), map_1((objectArg = e_5.dataTransfer.files, (index) => (objectArg[index])), list_8)));
                            setIsDrag(false);
                        }], (elems_5 = [(elms_3 = toList(delay(() => append(singleton(createElement("input", createObj(cons(["type", "file"], Helpers_combineClasses("file-input", ofArray([["type", "file"], ["multiple", true], ["onChange", (ev) => {
                            const fileList = ev.target.files;
                            if (!(fileList == null)) {
                                setFiles(toList(delay(() => map_2((i) => fileList.item(i), rangeDouble(0, 1, fileList.length - 1)))));
                            }
                        }]])))))), delay(() => {
                            let elms_2, elms_1;
                            return append(singleton((elms_2 = ofArray([(elms_1 = singleton_1(Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-file-upload"])), [])), createElement("span", {
                                className: "file-icon",
                                children: reactApi.Children.toArray(Array.from(elms_1)),
                            })), createElement("span", {
                                className: "file-label",
                                children: "Choose Documents...",
                            })]), createElement("span", {
                                className: "file-cta",
                                children: reactApi.Children.toArray(Array.from(elms_2)),
                            }))), delay(() => {
                                const matchValue_1 = files;
                                let matchResult, file_1;
                                if (!isEmpty(matchValue_1)) {
                                    if (isEmpty(tail(matchValue_1))) {
                                        matchResult = 0;
                                        file_1 = head(matchValue_1);
                                    }
                                    else {
                                        matchResult = 1;
                                    }
                                }
                                else {
                                    matchResult = 1;
                                }
                                switch (matchResult) {
                                    case 0:
                                        return singleton(createElement("span", {
                                            className: "file-name",
                                            children: file_1.name,
                                        }));
                                    default:
                                        return singleton(createElement("span", {
                                            className: "file-name",
                                            children: `${length(files)} documents`,
                                        }));
                                }
                            }));
                        })))), createElement("label", {
                            className: "file-label",
                            children: reactApi.Children.toArray(Array.from(elms_3)),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))]));
                    })))))))))))), createElement("div", {
                        className: "field",
                        children: reactApi.Children.toArray(Array.from(elms_4)),
                    }))), delay(() => singleton("This step will be completed as you")));
                }));
            }));
        })), react.createElement(react.Fragment, {}, ...xs_19)),
        disabled: disabled,
        footer: singleton_1(createElement("button", createObj(Helpers_combineClasses("button", toList(delay(() => append(singleton(["children", "Complete"]), delay(() => append(singleton(["className", "is-small"]), delay(() => append(singleton(["className", "is-success"]), delay(() => append(singleton(["disabled", disabled]), delay(() => append(disabled ? singleton(["className", "is-loading"]) : empty_1(), delay(() => singleton(["onClick", (_arg_9) => {
            complete();
        }]))))))))))))))))),
        title: `Complete Step #${stepIndex}: ${actionStep.Name}`,
    });
}

export function CompleteImageOrVideoStep(completeImageOrVideoStepInputProps) {
    let xs;
    const captureKind = completeImageOrVideoStepInputProps.captureKind;
    const close = completeImageOrVideoStepInputProps.close;
    const actionStep = completeImageOrVideoStepInputProps.actionStep;
    const activityId = completeImageOrVideoStepInputProps.activityId;
    const stepIndex = completeImageOrVideoStepInputProps.stepIndex;
    const projectId = completeImageOrVideoStepInputProps.projectId;
    const patternInput = reactApi.useState(false);
    const setDisabled = patternInput[1];
    const disabled = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setError = patternInput_1[1];
    const patternInput_2 = reactApi.useState(empty_2());
    const attachments = patternInput_2[0];
    let complete;
    const dependencies_1 = [attachments];
    complete = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            setError(undefined);
            setDisabled(true);
            const completeStep = new Activities_CompleteActivityStep(actionStep.Id, undefined, undefined, (captureKind === "video") ? (new Activities_EvidenceType(5, [])) : (new Activities_EvidenceType(4, [])), undefined);
            return completeStepWithAttachments(projectId, activityId, completeStep, attachments).then((_arg) => {
                const result = _arg;
                setDisabled(false);
                if (result.tag === 1) {
                    setError(result.fields[0]);
                    return Promise.resolve();
                }
                else {
                    close(true);
                    return Promise.resolve();
                }
            });
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithFooter, {
        close: () => {
            close(false);
        },
        content: (xs = toList(delay(() => {
            let matchValue, e;
            return append((matchValue = patternInput_1[0], (matchValue == null) ? (empty_1()) : ((e = matchValue, (console.error(some(e)), singleton(createElement(Components_FetchErrorNotification, {
                error: e,
            })))))), delay(() => append(singleton(createElement(Components_VideoFeed, {
                captureKind: captureKind,
                disabled: disabled,
                onAttachmentsChange: patternInput_2[1],
            })), delay(() => singleton("This step will be completed as you")))));
        })), react.createElement(react.Fragment, {}, ...xs)),
        disabled: disabled,
        footer: singleton_1(createElement("button", createObj(Helpers_combineClasses("button", toList(delay(() => append(singleton(["children", "Complete"]), delay(() => append(singleton(["className", "is-small"]), delay(() => append(singleton(["className", "is-success"]), delay(() => append(singleton(["disabled", disabled]), delay(() => append(disabled ? singleton(["className", "is-loading"]) : empty_1(), delay(() => singleton(["onClick", (_arg_1) => {
            complete();
        }]))))))))))))))))),
        title: `Complete Step #${stepIndex}: ${actionStep.Name}`,
    });
}

export function ChangeCategory(changeCategoryInputProps) {
    let elms;
    const close = changeCategoryInputProps.close;
    const activities = changeCategoryInputProps.activities;
    const projectId = changeCategoryInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const categoryOpt = patternInput_1[0];
    let initialCategory;
    const dependencies_1 = [activities];
    initialCategory = reactApi.useMemo(() => {
        const categories = choose((m) => m.Category, activities);
        if (length(List_groupBy((x) => x, categories, {
            Equals: equals_1,
            GetHashCode: safeHash,
        })) > 1) {
            return undefined;
        }
        else {
            return tryHead(categories);
        }
    }, dependencies_1);
    let assigns;
    const dependencies_1_1 = [categoryOpt];
    assigns = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            const changeCategory = new Activities_ChangeCategory(categoryOpt);
            const name = defaultArg(map(toString, categoryOpt), "None");
            return PromiseBuilder__For_1565554B(promise, activities, (_arg) => {
                const activity = _arg;
                taskDispatch(new TaskMsg(0, [activity.Id, `Assign ${activity.Name} To Category : ${name}`]));
                taskDispatch(new TaskMsg(2, [activity.Id]));
                return changeCategory_1(projectId, activity.Id, changeCategory).then((_arg_1) => {
                    const result = _arg_1;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(6, [activity.Id, result.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [activity.Id, undefined]));
                        return Promise.resolve();
                    }
                });
            });
        }));
        void pr;
    }, dependencies_1_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (elms = ofArray([createElement("label", {
            className: "label",
            children: "Category",
        }), createElement(CategorySelector_CategorySelector, {
            value: unwrap(initialCategory),
            required: true,
            onChange: patternInput_1[1],
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms)),
        })),
        submit: assigns,
        submitText: "Change",
        tasks: patternInput[0],
        title: "Change Category",
    });
}

export function ChangeMaturity(changeMaturityInputProps) {
    let elms;
    const close = changeMaturityInputProps.close;
    const activities = changeMaturityInputProps.activities;
    const projectId = changeMaturityInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const maturityOpt = patternInput_1[0];
    let initialMaturity;
    const dependencies_1 = [activities];
    initialMaturity = reactApi.useMemo(() => {
        const maturities = choose((m) => m.Maturity, activities);
        if (length(List_groupBy((x) => x, maturities, {
            Equals: equals_1,
            GetHashCode: safeHash,
        })) > 1) {
            return undefined;
        }
        else {
            return tryHead(maturities);
        }
    }, dependencies_1);
    let assigns;
    const dependencies_1_1 = [maturityOpt];
    assigns = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            const assignMaturity = new Activities_ChangeMaturity(maturityOpt);
            const name = defaultArg(map(toString, maturityOpt), "None");
            return PromiseBuilder__For_1565554B(promise, activities, (_arg) => {
                const activity = _arg;
                taskDispatch(new TaskMsg(0, [activity.Id, `Assign ${activity.Name} To Maturity : ${name}`]));
                taskDispatch(new TaskMsg(2, [activity.Id]));
                return changeMaturity(projectId, activity.Id, assignMaturity).then((_arg_1) => {
                    const result = _arg_1;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(6, [activity.Id, result.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [activity.Id, undefined]));
                        return Promise.resolve();
                    }
                });
            });
        }));
        void pr;
    }, dependencies_1_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (elms = ofArray([createElement("label", {
            className: "label",
            children: "Maturity",
        }), createElement(MaturitySelector_MaturitySelector, {
            value: unwrap(initialMaturity),
            required: true,
            onChange: patternInput_1[1],
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms)),
        })),
        submit: assigns,
        submitText: "Change",
        tasks: patternInput[0],
        title: "Change Maturity",
    });
}

export function ChangeAction(changeActionInputProps) {
    let elms;
    const close = changeActionInputProps.close;
    const activities = changeActionInputProps.activities;
    const projectId = changeActionInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const actionOpt = patternInput_1[0];
    let initialAction;
    const dependencies_1 = [activities];
    initialAction = reactApi.useMemo(() => {
        const actions = choose((m) => m.ActionId, activities);
        if (length(List_groupBy((x) => x, actions, {
            Equals: (x_1, y) => (x_1 === y),
            GetHashCode: stringHash,
        })) > 1) {
            return undefined;
        }
        else {
            return tryHead(actions);
        }
    }, dependencies_1);
    let assigns;
    const dependencies_1_1 = [actionOpt];
    assigns = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            const name = defaultArg(map(DomainEntity__get_Name, actionOpt), "None");
            const assignAction = new Activities_ChangeAction(map(DomainEntity__get_Id, actionOpt));
            return PromiseBuilder__For_1565554B(promise, activities, (_arg) => {
                const activity = _arg;
                taskDispatch(new TaskMsg(0, [activity.Id, `Assign ${activity.Name} To Action : ${name}`]));
                taskDispatch(new TaskMsg(2, [activity.Id]));
                return changeAction(projectId, activity.Id, assignAction).then((_arg_1) => {
                    const result = _arg_1;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(6, [activity.Id, result.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [activity.Id, undefined]));
                        return Promise.resolve();
                    }
                });
            });
        }));
        void pr;
    }, dependencies_1_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (elms = ofArray([createElement("label", {
            className: "label",
            children: "Action",
        }), createElement(DomainEntitySelector, {
            projectId: projectId,
            entityType: new DomainEntities(11, []),
            initialEntity: unwrap(initialAction),
            onSelectedEntityChange: patternInput_1[1],
            filters: empty_2(),
            isSmall: false,
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms)),
        })),
        submit: assigns,
        submitText: "Change",
        tasks: patternInput[0],
        title: "Change Action",
    });
}

